import { configureStore, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { authApi } from '../api';
import { AuthState, TUserAuthTokenPayload } from '../types';

const initialState: AuthState = {
    isAuthenticated: null,
    user: null,
    token: null,
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        clearCredentials: (state) => {
            state.user = null;
            state.token = null;
            state.isAuthenticated = false;
            localStorage.removeItem('accessToken');
        },
        setCredentials: (
            state,
            {
                payload: { accessToken, user },
            }: PayloadAction<{
                accessToken: string;
                user: TUserAuthTokenPayload;
            }>,
        ) => {
            state.token = accessToken;
            state.user = user;
            state.isAuthenticated = true;
        },
        setToken: (state, { payload }: PayloadAction<string>) => {
            state.token = payload;
        },
    },
});

//! This is dummy store for authApi, do not use it in the app.
export const _authStore = configureStore({
    reducer: {
        [authSlice.name]: authSlice.reducer,
        [authApi.reducerPath]: authApi.reducer,
    },
    middleware: (gDM) => gDM().concat(authApi.middleware),
});

export const { clearCredentials, setCredentials, setToken } = authSlice.actions;
